/* eslint-disable import/no-anonymous-default-export */
// @ts-nocheck
import Raupload from './raupload';
import { isRaUploadReadWriteDelete } from 'models/user/selector';
import RaUploadReducer from './reducer';
import RaUploadSagas from './sagas';

export default [
	{
		path: '/raupload',
		key: 'key',
		componentId: 'raupload',
		component: (props) => <Raupload title="asd" {...props} />,
		routes: [],
		importReducer: () => {
			return [RaUploadReducer];
		},
		importSagas: () => {
			return [RaUploadSagas];
		},
		title: 'Skulicity | RA upload',
		headerName: 'RA Upload',
		name: 'Ra Upload',
		isEnabled: (state) => isRaUploadReadWriteDelete(state),
	},
];
